/**
 * This file is copied from the Quick Start-guide for the RepoList application
 * that has been registered at Auth0.com. The purpose of this file is to prevent
 * unauthorized access to pages tagged with "beforeEnter: authGuard" in the
 * Vue router.
 * Staffan: But I have added the possibility to get through to the requested page without
 * login if an "ott" (One time token) request parameter has been given.
 */
import { getInstance } from "./index";

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = () => {
    // If the user is authenticated, continue with the route
    const queryString = window.location.search;
    console.log(queryString);
    const urlParams = new URLSearchParams(queryString);
    const ott = urlParams.get('ott')
    if (ott || authService.isAuthenticated) {
      return next();
    }

    // Otherwise, log in
    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return fn();
  }

  // Watch for the loading property to change before we check isAuthenticated
  authService.$watch("loading", loading => {
    if (loading === false) {
      return fn();
    }
  });
};
